import { UserRoleEnum } from "./auth.service";

export const UserRoleTranslations = {
  [UserRoleEnum.None]: '',
  [UserRoleEnum.Admin]: 'Admin'
};
